import { Box, Card, CardContent, Link, Stack, Typography } from '@mui/material';
import { t } from 'i18next';
import { FilterStatusBadge } from '../../../../common/components/FilterStatusBadge';
import { SeverityBadge } from '../../../../common/instances/components/SeverityBadge';
import { UrlHelper } from '../../../../common/utils/UrlHelper';
import { RemediationDetails } from '../../../../reports/issues/issue/instance/components/RemediationDetails';
import { PATHS } from '../../../../routing/routes';
import { InstancePrintData } from '../models/InstancePrintData';
import { InstanceCounters } from './InstanceCounters';
import { IssueDetails } from './IssueDetails';

type Props = {
  instance: InstancePrintData;
};

export const InstanceDetails = ({ instance }: Props) => {
  const issue = instance.getIssue();
  const number = instance.getNumber();
  const issueNumber = issue?.getNumber() ?? '';
  const numberLocal = instance.getNumberLocal() ?? '';
  const data = instance.getData();
  const remediation = instance.getRemediation();
  const specificTag = instance.getSpecificRemediationTag();
  const reportId = instance.getReport().getId();

  return (
    <Card>
      <CardContent>
        <Stack direction="row" gap={2} height="2rem">
          <SeverityBadge severity={instance.getSeverity()}>
            {issueNumber}.{numberLocal}
          </SeverityBadge>
          <FilterStatusBadge format="large" filterStatus={instance.getFilterStatus()} />
        </Stack>
        <Typography variant="h3" sx={{ pt: 3, mb: 2, fontSize: '1.75rem', wordBreak: 'break-word' }}>
          {data}
        </Typography>
        <Box sx={{ mb: 2 }}>
          <Link
            href={UrlHelper.generatePath(PATHS.REPORT_ISSUE_INSTANCE, {
              reportId: reportId.toString(),
              issueId: issueNumber.toString(),
              instanceId: number.toString(),
            })}
          >
            {t('exportsGenericLinkToAQtiveGuard')}
          </Link>
        </Box>
        <Box sx={{ mb: 2 }}>
          <RemediationDetails remediation={remediation} specificTag={specificTag} sectionSpacing={2} />
        </Box>
        <Box sx={{ mb: 2 }}>
          <InstanceCounters calls={instance.getCallsCount()} operations={instance.getOperationsCount()} locations={instance.getLocationsCount()} />
        </Box>
        <Box sx={{ mb: 2 }}>{issue && <IssueDetails reportId={reportId} issue={issue} />}</Box>
      </CardContent>
    </Card>
  );
};
